
import { Component, Prop, Vue } from 'vue-property-decorator';
import { NavBar, BaseModal } from '@warrenbrasil/nebraska-web';

import { CloseButton } from '@/modules/common/components/buttons';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';
import { FeatureFlags } from '@/types/models/FeatureFlags';
import { LegacyTransferDetails } from '../LegacyTransferModal/components/LegacyTransferDetails';
import TransferWithdrawalDetails from './components/TransferWithdrawalDetails/TransferWithdrawalDetails.vue';

@Component({
  components: {
    BaseModal,
    CloseButton,
    NavBar,
    LegacyTransferDetails,
    TransferWithdrawalDetails
  }
})
export default class TransferWithdrawalModal extends Vue {
  @Prop({ type: String, required: true })
  private id!: string;

  @Prop({ type: Boolean, default: false })
  private isOpen!: boolean;

  private get computedAs() {
    return this.isEnabledNewWithdrawDetails
      ? 'TransferWithdrawalDetails'
      : 'LegacyTransferDetails';
  }

  private get isEnabledNewWithdrawDetails() {
    return FeatureFlagsModule.isEnabled(
      FeatureFlags.NEW_WALLET_WITHDRAW_DETAILS
    );
  }
}
